<div>
  <!--Action Panel-->
  <div class="cc-action-panel row">

    <!--Filters-->
    <div class="user-skills-filters row">
      <div class="col-md-12 d-flex">
        <div class="me-3">
          <label>{{'_General_Category_Text_' | translate }}</label>
  
          <select id="category" class="cc-select-dropdown form-control" [(ngModel)]="category" (change)="applyFilters()">
            <option value="-1">{{'_General_All_Text_' | translate }}</option>
            <option [ngValue]="category.id" *ngFor="let category of categoryList">{{category.displayValue}}</option>
          </select>
        </div>
        <div class="me-3">
          <label>{{'_General_Opt_In_Status_Text_' | translate }}</label>
          <select id="opt-in-status" class="cc-select-dropdown form-control" [(ngModel)]="optStatus"
            (change)="applyFilters()">
            <option value="1">{{'_General_Opted_In_Sub_Text_' | translate }}</option>
            <option value="0">{{'_General_Opted_Out_Sub_Text_' | translate }}</option>
            <option value="-1">{{'_General_All_Text_' | translate }}</option>
          </select>
        </div>
      </div>
    </div>

    <!--Search-->
    <div class="cc-search">
      <input placeholder="{{'_General_Search_Text_' | translate }}" class="form-control" [(ngModel)]="search" (keydown.enter)="applyFilters()"
        (ngModelChange)="onSearchTextChanges()" />
      <button class="cc-close-btn" type="button" [ngClass]="{'show-btn': showClearButton}"
        (click)="onClearSearchTextClicked()"><span class="fas fa-times"></span></button>
      <button class="cc-search-btn" type="button" (click)="applyFilters()"><span class="fas fa-search"></span></button>
    </div>

  </div>
</div>
<kendo-grid [kendoGridBinding]="dataSkillGrid" [sortable]="{allowUnsort: false, mode: 'single'}" scrollable="scrollable"
  [sort]="sort" [pageable]="true" [pageSize]="pageInfo.PageSize" [skip]="(pageInfo.Page - 1) * pageInfo.PageSize"
  [selectable]="{enabled: true, checkboxOnly: true }" kendoGridSelectBy="id" [selectedKeys]="skillsSelection"
  (selectedKeysChange)="onSelectedKeysChange()" (edit)="editHandler($event)" (pageChange)="onPageChange($event)">
  <kendo-grid-messages pagerFirstPage="{{'_Go_To_First_Page_Text_' | translate}}" pagerLastPage="{{'_Go_To_Last_Page_Text_' | translate}}" pagerNextPage="{{'_Go_To_Next_Page_Text_' | translate}}" pagerPreviousPage="{{'_Go_To_Previous_Page_Text_' | translate}}" pagerPage="{{'_Page_Grid_Text_' | translate}}" noRecords="{{'_NoRecords_Grid_Text_' | translate}}" pagerItems="{{'_General_Kendo_Grid_Pageable_Items_Text_' | translate}}" pagerOf="{{'_General_Kendo_Grid_Pageable_Of_Text_' | translate}}"></kendo-grid-messages>
  <kendo-grid-checkbox-column field="optIn" [width]="100" [headerStyle]="{'font-weight' : 'bold', 'text-align':'center', 'justify-content': 'center'}">
    <ng-template kendoGridHeaderTemplate>{{'_General_Option_Opt_In_Text_' | translate }}
      <input class="k-checkbox ms-2
      " id="selectAllCheckboxId" kendoGridSelectAllCheckbox [state]="selectAllState"
        (selectAllChange)="onSelectAllChange($event)" [disabled]="(dataSkillGrid) && dataSkillGrid.length == 0">
    </ng-template>

    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="cell-items-center">
      <input kendoCheckBox class="checkbox-cell" (change)="checkedChangedEvent($event, dataItem)" type="checkbox" [checked]="dataItem.optIn"
        [disabled]="!dataItem.editable" />
      </div>
    </ng-template>
    
  </kendo-grid-checkbox-column>


  <kendo-grid-column title="{{'_General_Service_Name_Text_' | translate }}" field="serviceName" [width]="200" [headerStyle]="{'font-weight' : 'bold'}">
  </kendo-grid-column>

  <kendo-grid-column title="{{'_General_Category_Text_' | translate }}" field="categoryName" [width]="200" [headerStyle]="{'font-weight' : 'bold'}">
  </kendo-grid-column>

  <kendo-grid-column title="{{'_General_Proficiency_Text_' | translate }}" field="proficiency" [width]="75" [headerStyle]="{'font-weight' : 'bold'}">
    <ng-template kendoGridCellTemplate let-dataItem class="input-hide-stepper">
      <input #proficeny class="form-control" type="number" min="0" max="100" (keypress)="onKeyPressProficiency($event,proficeny.value)" (keyup)="validateProficiency()" (change)="validateProficiency()"
        title="Proficiency" field="proficiency" [value]="dataItem.proficiency" [disabled]="!dataItem.editable" [(ngModel)]="dataItem.proficiency"/>
      <div *ngIf="dataItem.isProficiencyInvalid" class="cc-validation">{{'_General_Proficiency_Required_Text_' | translate }}</div>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-command-column title="{{'_General_Button_Action_Text_' | translate }}" [width]="100" [headerStyle]="{'font-weight' : 'bold', 'text-align':'center', 'justify-content': 'center'}">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="cell-items-center">
        <button type="button" [iconClass]="'fas fa-pen cc-icon-btn'" title="{{'_General_Button_Edit_Text_' | translate }}" kendoGridEditCommand
          *ngIf="!dataItem.editable" [disabled]="!dataItem.editable && editingItem"></button>
        <button type="button" class="fas fa-save cc-icon-btn" title="{{'_General_Button_Submit_Text_' | translate }}" *ngIf="dataItem.editable"
          (click)="submitUserService(dataItem)" [disabled]="dataItem.isProficiencyInvalid" [ngClass]="(dataItem.isProficiencyInvalid ||isProficiencyChanged) ? 'fa-button-disabled' : ''"></button>
        <button type="button" class="fas fa-times cc-icon-btn" title="{{'_General_Button_Cancel_Text_' | translate }}" *ngIf="dataItem.editable"
          (click)="cancelUserService(dataItem)"></button>
      </div>
    </ng-template>
  </kendo-grid-command-column>

</kendo-grid>

<!-- Button Panel -->
<div class="cc-btn-panel">
  <button (click)="cancelGridData()" class="btn btn-secondary">{{'_General_Button_Close_Text_' | translate }}</button>
  <button (click)="saveGridData()" class="btn btn-primary" [disabled]="!(isSkillsEdited && isSkillsValid)">{{'_General_Button_Save_Text_' | translate }}</button>
</div>
